import { render, staticRenderFns } from "./NTF-Stacked.vue?vue&type=template&id=42cac4fa&"
import script from "./NTF-Stacked.vue?vue&type=script&lang=js&"
export * from "./NTF-Stacked.vue?vue&type=script&lang=js&"
import style0 from "./NTF-Stacked.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports